export const PROGRESS_INDICATOR = {
  OVERLAY: 'progress-indicator-overlay',
  SPINNER: 'progress-indicator-spinner'
} as const;
